import { createContext } from 'react';
import { ISubCategoryPositionItemV2 } from 'types';

export type TChangeSubCategoryPositionSelectedRestaurant = { id: string; name: string };
export type TTypeOfChangeSubCategoryPositionModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSave'
	| 'success'
	| 'error';

export interface IChangeSubCategoryPositionState {
	IDSelectedCustomer: Nullable<string>;
	selectedRestaurant: Nullable<TChangeSubCategoryPositionSelectedRestaurant>;
	IDSelectedCategory: Nullable<string>;
	positionsData: ISubCategoryPositionItemV2[];
	typeOfModalWindow: TTypeOfChangeSubCategoryPositionModalWindow;
	isVisibleAdditionalRestaurantsModal: boolean;
	isApplyToOne: boolean;
	selectedAdditionalRestaurants: TChangeSubCategoryPositionSelectedRestaurant[];
	selectSearchString: string;
}

export const changeSubCategoryPositionInitialState: IChangeSubCategoryPositionState = {
	IDSelectedCustomer: null,
	selectedRestaurant: null,
	IDSelectedCategory: null,
	positionsData: [],
	typeOfModalWindow: null,
	isVisibleAdditionalRestaurantsModal: false,
	isApplyToOne: false,
	selectedAdditionalRestaurants: [],
	selectSearchString: '',
};

export interface IChangeSubCategoryPositionContext extends IChangeSubCategoryPositionState {
	setIDCustomer(value: Nullable<string>): void;
	setRestaurant(value: Nullable<TChangeSubCategoryPositionSelectedRestaurant>): void;
	setIDCategory(value: Nullable<string>): void;
	resetSelectedControls(): void;
	setPositionsData(data: ISubCategoryPositionItemV2[]): void;
	reorderItems(value: ISubCategoryPositionItemV2[]): void;
	changeTypeOfModalWindow(value: TTypeOfChangeSubCategoryPositionModalWindow): void;
	setVisibleAdditionalRestaurantsModal(value: boolean): void;
	toggleApplyToOne(): void;
	setAdditionalRestaurants(value: TChangeSubCategoryPositionSelectedRestaurant[]): void;
	changeSelectSearchString(value: string): void;
}

export const ChangeSubCategoryPositionContext = createContext<IChangeSubCategoryPositionContext>({
	setIDCustomer: () => undefined,
	setRestaurant: () => undefined,
	setIDCategory: () => undefined,
	resetSelectedControls: () => undefined,
	setPositionsData: () => undefined,
	reorderItems: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setVisibleAdditionalRestaurantsModal: () => undefined,
	toggleApplyToOne: () => undefined,
	setAdditionalRestaurants: () => undefined,
	changeSelectSearchString: () => undefined,
	...changeSubCategoryPositionInitialState,
});
